/**
 * Created by jacmai on 2/24/2017.
 */

define([
  "backbone",
  "messaging/messenger",
  "configuration/properties",
  "modules/actions/actionGroup/actionGroupItems/actionGroupItemsModel",
], function (Backbone, Messenger, Properties, ActionGroupItemsModel) {
  var ActionsModel = {};

  ActionsModel.actionGroup = Backbone.Model.extend({
    idAttribute: "actionGroupId",
    defaults: {
      name: "",
      description: "",
    },
    defaultValidateAttributes: ["name", "description"],
    actionItems: function () {
      if (!this.actionItemsCol) {
        this.actionItemsCol = new ActionGroupItemsModel.actionItemsCol();
        //Fetch the collection from the server, passing the actionGroup Id which is necessary for the request
        if (!this.isNew()) {
          this.actionItemsCol.fetch(this.id);
        }
        this.subModels = [this.actionItemsCol];
      }
      return this.actionItemsCol;
    },
    saveChildren: function (options) {
      //pass all the data needed to the child models for saving
      if (this.actionItemsCol) {
        this.actionItemsCol.actionGroupId = this.id;
      }
      this.saveSubModels(options);
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "name") {
        return (
          this.validateRequiredValue(value, { maxLength: 100 }) ||
          this.validateSafeCharacters(value)
        );
      }
      if (attribute === "description") {
        return this.validateStringLength(value, { maxLength: 500 });
      }
    },
    //define a URL Root for when requesting the model outside of collection
    urlRoot: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/actiongroup";
    },
  });

  ActionsModel.actionGroups = Backbone.Collection.extend({
    model: ActionsModel.actionGroup,
    addGroup: function () {
      return this.add({});
    },
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "name");
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/actiongroup";
    },
  });

  Messenger.reqres.setHandler("action:group", function (actionGroupId) {
    if (actionGroupId > 0) {
      var group = new ActionsModel.actionGroup({ actionGroupId: actionGroupId });
      group.fetch();
      return group;
    }
    return null;
  });

  Messenger.reqres.setHandler("action:groups", function () {
    var groups = new ActionsModel.actionGroups();
    groups.fetch();
    return groups;
  });
});
